// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3592":"e2d9967c","4144":"13ab2ca5","5241":"66c9b3cd","5635":"13ab2ca5","5728":"4e5d7f55","5784":"bc708304","6214":"5fe82e92","6710":"dde8d477","9565":"b5d7cd67"}[chunkId] + ".chunk.css";
};